import React, { Component } from 'react';
import { CMSPath, DEMO, ROOMCONTROLTYPE } from '../../../config/constant'
import InnComRoomControl from './InnComRoomControl/InnComRoomControl';
// import VDARoomControl from './VDARoomControl/VDARoomControl'
import VDARoomControl from './VDARoomControl/VDARoomControl'
// import LutronRoomControl from './LutronRoomControl/LutronRoomControl'
class RoomControl extends Component {
    
    getRoomControl = () => {
        switch( (localStorage.getItem("roomControlInterface") || process.env.REACT_APP_ROOMCONTROLTYPE) ){
            case 'InnCom': return <InnComRoomControl />
            case 'Lutron': return <InnComRoomControl /> //<LutronRoomControl />
            case 'VDA': return <VDARoomControl />
            default: return <InnComRoomControl />
        }
    }

    render() {
        return this.getRoomControl();
    }
}

export default RoomControl;